module.exports = __webpack_public_path__ + "static/media/condenser-02.b87a09b9.png";